const autocompleteModalEquipServQuest = {
  group: 'Seção'
};

export default autocompleteModalEquipServQuest;
